import { render, staticRenderFns } from "./RegionalManagement.vue?vue&type=template&id=03d83a1c&scoped=true&"
import script from "./RegionalManagement.vue?vue&type=script&lang=js&"
export * from "./RegionalManagement.vue?vue&type=script&lang=js&"
import style0 from "./RegionalManagement.vue?vue&type=style&index=0&id=03d83a1c&lang=scss&scoped=true&"
import style1 from "./RegionalManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d83a1c",
  null
  
)

export default component.exports